export default class CricketMatchData {

    constructor(hasAutoUpdate = false) {
        this.hasAutoUpdate = hasAutoUpdate;
    }

    getPositions()
    {
        return ['Batter', 'Bowler', 'All Rounder', 'Keeper'];
    }

    getFields()
    {
        return [
            {
                name: "runs",
                label: "Runs Scored",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "ballsFaced",
                label: "Balls Faced",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "notOut",
                label: "Not Out",
                type: "checkbox",
                initialValue: false,
                selectAll: false
            },
            {
                name: "dnb",
                label: "Dnb",
                type: "checkbox",
                initialValue: true,
                selectAll: false
            },
            {
                name: "catches",
                label: "Catches",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "runOuts",
                label: "Run Outs",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "stumpings",
                label: "Stumpings",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "oversBowled",
                label: "Overs",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "maidens",
                label: "Maidens",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "wickets",
                label: "Wickets",
                type: "number",
                initialValue: null,
                selectAll: false
            },
            {
                name: "runsAgainst",
                label: "Runs Against",
                type: "number",
                initialValue: null,
                selectAll: false
            },
        ]
    }

    getFieldsForUserDisplay(userIsPremium = false) {
        return [
            {
                name: "innings",
                label: "Inns",
                labelPlural: "Inns",
                type: "number",
                hidden: !userIsPremium
            },
            {
                name: "runs",
                label: "Runs",
                labelPlural: "Runs",
                type: "number",
                hidden: false
            },
            {
                name: "battingAverage",
                label: "Bat Avg",
                labelPlural: "Bat Avg",
                type: "number",
                hidden: true
            },
            {
                name: "battingStrikeRate",
                label: "Bat SR",
                labelPlural: "Bat SR",
                type: "number",
                hidden: true
            },
            {
                name: "topScore",
                label: "Top Score",
                labelPlural: "Top Score",
                type: "number",
                hidden: true
            },
            {
                name: "fours",
                label: "Fours",
                labelPlural: "Fours",
                type: "number",
                hidden: true
            },
            {
                name: "sixes",
                label: "Sixes",
                labelPlural: "Sixes",
                type: "number",
                hidden: true
            },
            {
                name: "notOuts",
                label: "Not Out",
                labelPlural: "Not Out",
                type: "number",
                hidden: true
            },
            {
                name: "catches",
                label: "Catches",
                labelPlural: "Catches",
                type: "number",
                hidden: false
            },
            {
                name: "runOuts",
                label: "Run Outs",
                labelPlural: "Run Outs",
                type: "number",
                hidden: false
            },
            {
                name: "stumpings",
                label: "Stmpgs",
                labelPlural: "Stmpgs",
                type: "number",
                hidden: false
            },
            {
                name: "oversBowled",
                label: "Overs",
                labelPlural: "Overs",
                type: "number",
                hidden: !userIsPremium
            },
            {
                name: "wickets",
                label: "Wickets",
                labelPlural: "Wickets",
                type: "number",
                hidden: false
            },
            {
                name: "runsAgainst",
                label: "Runs Ag",
                labelPlural: "Runs Ag",
                type: "number",
                hidden: false
            },
            {
                name: "maidens",
                label: "Mdns",
                labelPlural: "Mdns",
                type: "number",
                hidden: false
            },
            {
                name: "bowlingAverage",
                label: "Bowl Avg",
                labelPlural: "Bowl Avg",
                type: "number",
                hidden: true
            },
            {
                name: "economy",
                label: "Economy",
                labelPlural: "Economy",
                type: "number",
                hidden: true
            },
            {
                name: "bowlingStrikeRate",
                label: "Bowl SR",
                labelPlural: "Bowl SR",
                type: "number",
                hidden: true
            }
        ];
    }

    getComparisonStatGroups() {
        return [
            {
                title: 'Batting',
                fields: [
                    { label: 'Innings', key: 'innings' },
                    { label: 'Runs scored', key: 'runs' },
                    { label: 'Batting average', key: 'battingAverage' },
                    { label: 'Strike rate', key: 'battingStrikeRate' },
                    { label: 'Fours', key: 'fours' },
                    { label: 'Sixes', key: 'sixes' },
                    { label: 'Top score', key: 'topScore' },
                ],
            },
            {
                title: 'Bowling',
                fields: [
                    { label: 'Overs bowled', key: 'oversBowled' },
                    { label: 'Maidens', key: 'maidens' },
                    { label: 'Wickets', key: 'wickets' },
                    { label: 'Runs against', key: 'runsAgainst' },
                    { label: 'Economy', key: 'bowlingEconomy', lowerIsBetter: true },
                    { label: 'Average', key: 'bowlingAverage', lowerIsBetter: true },
                    { label: 'Strike rate', key: 'bowlingStrikeRate', lowerIsBetter: true },
                ],
            },
            {
                title: 'Fielding',
                fields: [
                    { label: 'Catches', key: 'catches' },
                    { label: 'Run outs', key: 'runOuts' },
                    { label: 'Stumpings', key: 'stumpings' },
                ],
            },
        ];
    }
}